import { Text } from "atomize"

// Etichetta accanto al nome (soprannome, livello PTR, archiviato)
function PlayerTag({ text, bg, textColor, title }) {
	return (
		<Text
			tag="span"
			textSize="caption"
			textWeight="bold"
			textColor={textColor}
			bg={bg}
			p={{ x: "0.5rem", y: "0.1rem" }}
			rounded="15px"
			title={title}
			style={{ whiteSpace: "nowrap" }}>
			{text}
		</Text>
	)
}

export default PlayerTag
